import React from 'react';

import { H2 } from './headline2-styled-component';

const Headline2 = props => {
  return <H2 {...props}>{props.children}</H2>;
};

export default Headline2;
